module.exports = __webpack_public_path__ + "img/kknn06.8e37cbba.jpg";